<dashboardnav>

  <cradua-pipeline-license-stage
  [pipelinelicensecategoryes]="pipelinelicensecategoryes$ | async"
  [pipelinelicensestages]="pipelinelicensestages$ | async"
  (changeEmit)="onSubmitPipelineLicenseStage($event)"
  (deleteEvent)="onDeletePipelineLicenseStage($event)"
  *ngIf="(isLoading$ | async ) === false"
  >
</cradua-pipeline-license-stage>

  <mrsoftapps-epims-reference-spinner
  *ngIf="(isLoading$ | async) === true"
>
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
